<template>
  <div class="my-info-page">
    <div class="head-img-block">
      <img class="img" src="../../images/icon/1.png" alt="" />
    </div>
    <div class="rz-block">
      <div class="line-block">
        <div class="card-icon">
          <img class="card-icon-img" src="../../images/icon/2.png" alt="" />
        </div>
        <div class="card-text">
          <div class="lx-font">实名认证</div>
          <div class="s-font">上传身份信息</div>
        </div>
        <div class="card-statu" v-if="isSM != 'true'">
          <div class="statu-text">去认证</div>
        </div>
        <div class="card-statu" v-if="isSM == 'true'">
          <div class="statu-text">已认证</div>
        </div>
      </div>

      <div class="rz-block" v-if="isSM != 'true'">
        <div class="line-block-phone">
          <div class="line-block-phone-title">身份信息</div>
          <div class="id-style">手机号码：{{ userInfo.phone }}</div>
          <div class="id-style">身份证号码：{{ userInfo.id_number }}</div>
          <div class="id-style">身份编码：{{ openid }}</div>
        </div>
      </div>

      <!-- <div class="rz-block" v-if="isSM != 'true'">
        <div class="line-block-phone">
          <div class="line-block-phone-title">手机验证</div>
          <div class="line-block-phone-input">
            <div class="tishi" style="margin-bottom: 0.2rem">
              *请首先点击获得验证码，获得验证码后填入验证码，进行实名认证的操作
            </div>
            <div class="input-block">
              <el-input
                v-model="input_phone_code"
                placeholder="请输入验证码"
              ></el-input>
              <el-button
               v-if="activeshow"
                class="input-button"
                type="success"
                @click="huode_code()"
                >{{ showcodetext }}</el-button
              >
               <el-button
               v-if="!activeshow"
                class="input-button"
                type="success"
                @click="huode_code()"
                :disabled="true"
                >重新发送{{ count }}秒</el-button
              >
            </div>
            <div class="rm-code">
              <el-button
                class="sm-button"
                type="success"
                @click="yanzheng_code()"
                >去实名认证</el-button
              >
            </div>
          </div>
        </div>
      </div> -->


       <div class="rz-block" v-if="isSM != 'true'">
        <div class="line-block-phone">
          <div class="line-block-phone-input">
       

            <div class="rm-code">
              <el-button
                class="sm-button"
                type="success"
                @click="yanzheng_code()"
                >去实名认证</el-button
              >
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import actions from "../../common/test.js";
import util from "../../common/util.js";
export default {
  components: {},
  data() {
    return {
      isSM: this.$route.query.type,
      get_info: "",
      input_phone_code: "",
      userInfo: {},
      showcodetext: "获得验证码",
      isactive: false,
      count:'',
      timer:null,
      activeshow:true,
      openid:util.getLocalStorage('openid')
    };
  },
  mounted() {
    this.getuerinfo();
  },
  created() {},
  updated() {},
  computed: {},
  watch: {},
  methods: {
    goPage(url_name) {
      if (this.isSM == "true") {
        return false;
      }
      this.$router.push({
        name: url_name,
      });
    },
    huode_code() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
      };
      actions.phone_validation(data).then((info) => {
        if (info.is_success == "yes") {
          this.get_info = info.content;
          this.showactivetext()
        } else {
          this.$message.error(
            "获取验证码失败，请检查身份证信息和手机号码是否准确！"
          );
        }
      });
    },
    yanzheng_code() {
      // if (this.get_info == "") {
      //   this.$message.error("请先获得验证码");
      //   return false;
      // }
      // if (this.input_phone_code == "") {
      //   this.$message.error("请先输入验证码");
      //   return false;
      // }
      // let data = {
      //   gzhid: util.getLocalStorage("openid"),
      //   key: this.get_info,
      //   code: this.input_phone_code,
      // };
      // actions.phone_validation_shiming(data).then((info) => {
      //   this.$router.push({ name: "myinfoupdate" });
      // });
      this.$router.push({ name: "myinfoupdate" });
    },

    getuerinfo() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
      };
      actions.getuser_info(data).then((info) => {
        this.userInfo = info.content[0];
      });
    },
    showactivetext() {
      // var wait = 60;
      // if (wait == 0) {
      //   this.showcodetext = "获取验证码";
      //   this.isactive = false
      //   wait = 60;
      // } else {
      //  this.isactive = true
      //   this.showcodetext = "重新发送(" + wait + ")";
      //   wait--;
      // }


       const TIME_COUNT = 60;
     if (!this.timer) {
        this.count = TIME_COUNT;
        this.activeshow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
           this.count--;
          } else {
           this.activeshow = true;
           clearInterval(this.timer);
           this.timer = null;
          }
        }, 1000)
      }
      

    },
  },
};
</script>

<style scoped lang="scss">
.my-info-page {
  position: relative;
  min-height: calc(100vh);
  .head-img-block {
    .img {
      width: 7.5rem;
    }
  }
  .rz-block {
    margin-top: 0.3rem;
    .line-block {
      width: 6.7rem;
      height: 1.4rem;
      background: #ffffff;
      box-shadow: 0rem 0rem 0.06rem #d3d3d3;
      margin: 0 auto;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-icon {
        margin-left: 0.2rem;
        margin-right: 0.2rem;
        .card-icon-img {
          width: 1.15rem;
        }
      }
      .card-text {
        width: 4rem;
        height: 1.4rem;

        .lx-font {
          font-size: 0.32rem;
          font-weight: 600;
          line-height: 0.65rem;
          margin-top: 0.1rem;
        }
        .s-font {
          font-size: 0.2rem;
        }
      }
      .card-statu {
        margin-right: 0.2rem;
        width: 1.1rem;
        .statu-text {
          color: #ecb94c;
          font-size: 0.3rem;
        }
      }
    }

    .line-block-phone {
      width: 6.7rem;
      background: #ffffff;
      box-shadow: 0rem 0rem 0.06rem #d3d3d3;
      margin: 0 auto;
      border-radius: 0.08rem;

      padding: 0.3rem 0.23rem;
      .line-block-phone-title {
        font-size: 0.26rem;
        font-weight: 600;
        margin-bottom: 0.2rem;
      }
      .input-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .input-button {
          margin-left: 0.1rem;
        }
      }
      .p-code {
        margin-top: 0.2rem;
      }
      .rm-code {
        // margin-top: 0.3rem;
        width: 100%;
        .sm-button {
          width: 100%;
        }
      }
    }
  }
}
.tishi {
  font-size: 0.2rem;
  line-height: 0.4rem;
  margin-top: 0.3rem;
  color: #f60;
}
.id-style {
  font-size: 0.2rem;
  line-height: 0.4rem;
}
</style>

